export default (transaction) => ({
  amount: transaction.amount,
  paymentMethod: transaction.paymentMethod,
  walletNumber: transaction.walletNumber,
  bankCountry:
    transaction.transactionData?.transaction_recipient?.requisites?.bank_country ||
    transaction.counterparty?.bank_country
});
